export default __webpack_public_path__ + "static/media/word.2726fa8d.svg";